<script>

import NewArticle from "@/views/components/cms/new/NewArticle.vue";

export default {
  name: "PflegeNew",
  components: {
    NewArticle,
  },
}
</script>

<template>
  <NewArticle :category-id=13></NewArticle>
</template>

<style scoped>

</style>
